<template>
  <div>
    <el-form ref="orderForm" :model="orderForm" :rules="rules" label-width="120px">
      <!-- 电话确认 -->
      <template v-if="dialogType === 1">
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="会员姓名">{{curRowchoose.memberName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="手机号码">{{curRowchoose.memberPhone}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="商品标题">测试测试测试</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item class="lineH" label="所含项目">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="购买数量">1221份</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="18">
            <el-form-item label="预约人数" prop="number">
              <el-input v-model="orderForm.number" autocomplete="off" placeholder="请输入预约人数" style="width:180px" @blur="timeNumber"></el-input>&nbsp;人
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="预约时间">2818-11-12 11:00</el-form-item>
          </el-col>
        </el-row>
        <el-row v-for="(i,index) in orderForm.timeBox" :key="index">
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="19">
            <el-form-item :label="'预约时间'+(index+1)" :prop="'timeBox.'+index+'.time'" :rules="rules.timeBox.time">
              <el-date-picker
                v-model="i.time"
                type="datetime"
                :placeholder="'选择预约时间'+(index+1)"
                style="width:180px;margin-bottom:15px "
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="seize"></div>
          </el-col>
          <el-col :span="19">
            <div class="tips red">
              <p>请跟会员确认：</p>
              <p>①本次体验的人数，若是多人是否需要提前帮顾客做好预约。</p>
              <p>②是否会准时到店。</p>
            </div>
          </el-col>
        </el-row>
        <el-row class="btnOptions">
          <el-button class="darkBtn" @click="close">取消</el-button>
          <el-button class="redBtn" @click="confirm">已跟顾客确认</el-button>
        </el-row>
      </template>
      <!-- 人工派单 -->
      <template v-else-if="dialogType === 2">
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="会员姓名">{{curRowchoose.memberName | filterRow}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="手机号码">{{curRowchoose.memberPhone}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="预约项目">
              <p v-for="(i,index) in curRowchoose.serviceList" :key="index">
                {{i.serviceName}}
                <!-- <span>{{i.courseStyle}}次</span> -->
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="预约时间" prop="time">{{curRowchoose.scheduleStartTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="创建时间" prop="time">{{curRowchoose.createTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="18">
            <el-form-item label="分配员工" prop="nthmen">
              <el-select v-model="orderForm.nthmen" placeholder="请选择员工" style="width:180px;">
                <el-option :label="i.staffName" :value="i.staffId" v-for="(i,index) in allStaffList" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="服务方式">{{curRowchoose.isHome == 1?'上门-'+curRowchoose.serviceAddr:'到店'}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="留言">{{curRowchoose.message | filterRow}}</el-form-item>
          </el-col>
        </el-row>
        <el-row class="btnOptions">
          <el-button class="darkBtn" @click="close">取消</el-button>
          <el-button class="redBtn" @click="submit" :disabled="openFlag">提交</el-button>
        </el-row>
      </template>
      <!-- 确认开单 -->
      <template v-else-if="dialogType === 3">
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="会员姓名">{{curRowchoose.memberName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="手机号码">{{curRowchoose.memberPhone}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="预约项目">
              <p v-for="(i,index) in curRowchoose.serviceList" :key="index">
                {{i.serviceName}}
                <!-- <span>{{i.courseStyle}}次</span> -->
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="员工">{{curRowchoose.technicianName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="是否上门">{{curRowchoose.isHome == 1?'是':'否'}}</el-form-item>          
          </el-col>
        </el-row>
        <el-row v-if="curRowchoose.isHome == 1">
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="上门地址" class="lineH">{{curRowchoose.serviceAddr}}</el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="21">
            <el-form-item label="消费密码" prop="payPwd" :class="{'paypass':!setpayPwd}">
              <el-input type="password" v-model="orderForm.payPwd" autocomplete="off" placeholder="请输入消费密码" style="width:180px" :disabled="setpayPwd == 1 || setpayPwd == 2"></el-input>&nbsp;&nbsp;<span class="forget red" @click="forgetPwd" v-if="!setpayPwd">忘记密码？</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <span class="grey" v-if="!setpayPwd">请顾客输入6位数消费密码</span>
              <div class="red" v-else>会员未设消费密码&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="primary" plain size="mini" round @click="toSetPwd">去设置</el-button></div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="erCode">
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <img src="../../assets/images/androidimg.png" alt="">
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="erCode">
          <el-col :span="5">
            <div class="seize"></div>
          </el-col>
          <el-col :span="19" class="scanFont">
              <p><b class="red">需顾客</b>打开憨妈妈小程序/APP的扫一扫，</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;扫描下方二维码，点击确认即可。</p>
          </el-col>
        </el-row> -->
        <el-row class="btnOptions">
          <el-button class="redBtn" @click="openOrder" :disabled="openFlag">提交</el-button>
        </el-row>
      </template>
      <template v-else-if="dialogType === 4">
        <el-row v-if="nextPart">
          <el-row>
            <el-col :span="3">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="会员姓名">{{curRowchoose.memberName}}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="手机号码">{{curRowchoose.memberPhone}}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="预约项目">
                <p v-for="(i,index) in curRowchoose.serviceList" :key="index">
                  {{i.serviceName}}
                  <!-- <span>{{i.courseStyle}}次</span> -->
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="员工">{{curRowchoose.technicianName}}</el-form-item>
            </el-col>
          </el-row>        
          <el-row style="margin-top:15px">
            <el-col :span="3">
              <div class="seize"></div>
            </el-col>
            <el-col :span="21">
              <el-form-item label="调理小结" prop="condition" class="paypass">
                <el-input
                  type="textarea"
                  v-model="orderForm.condition"
                  autocomplete="off"
                  style="width:250px;height:90px;"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <!-- <el-row v-else>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="21">
            <el-form-item label="下次预约时间" prop="nexttime" class="nextTimeChoose">
              <el-date-picker
                v-model="orderForm.nexttime"
                type="date"
                placeholder="选择下次预约时间"
                style="width:210px"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions1"
              ></el-date-picker><br/>
              <el-time-select placeholder="起始" v-model="orderForm.startTime" style="width:100px" :picker-options="{start: conputedNow,end: computedEnd}"></el-time-select>
              <el-time-select placeholder="结束" v-model="orderForm.endTime" style="width:100px" :picker-options="{start: computedStart ,end: shopHours.split('-')[1] ,minTime: orderForm.startTime}"></el-time-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row class="btnOptions">
          <el-button class="redBtn" @click="submit" :disabled="openFlag">提交</el-button>
        </el-row>
      </template>
      <!-- 取消服务单 -->
      <template v-else-if="dialogType === 5">
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="会员姓名">{{curRowchoose.memberName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="手机号码">{{curRowchoose.memberPhone}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="预约项目">
              <p v-for="(i,index) in curRowchoose.serviceList" :key="index">
                {{i.serviceName}}
                <!-- <span>{{i.courseStyle}}次</span> -->
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="预约时间" prop="time">{{curRowchoose.scheduleStartTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="创建时间" prop="time">{{curRowchoose.createTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="18">
            <el-form-item label="员工">{{curRowchoose.technicianName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="seize"></div>
          </el-col>
          <el-col :span="18">
            <el-form-item label="取消原因" prop="cancelReason">
              <el-select v-model="orderForm.cancelReason" placeholder="请选择取消原因" style="width:180px;">
                <el-option label="顾客迟到时间太久" value="顾客迟到时间太久"></el-option>
                <el-option label="沟通联系后确定取消" value="沟通联系后确定取消"></el-option>
                <el-option label="其他原因" value="其他原因"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="btnOptions">
          <el-button class="darkBtn" @click="close">取消</el-button>
          <el-button class="redBtn" @click="cancelSubmit" :disabled="openFlag">提交</el-button>
        </el-row>
      </template>
    </el-form>
  </div>
</template>
<script>
import { formatDate } from '@/components/common/js/date.js';
import {technicianList, storeInfo, allStaff, checkMemAccountPwd, endOrderServe, insertManualAssign, startOrderServe, appointNextOrderServe, cancelServiceOrder, memDetail} from '@/api';
import CryptoJS from 'crypto-js'

export default {
  props: ["dialogType",'curRowchoose','nextPart','dialogTableVisible'],
  data() {
    // 数字(正整数)
    const isvalidateNumber = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^[1-9]\d*$/.test(value) == false) {
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 密码
    var validatePass = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为数字，请设置正确格式的密码"));
      // } else if (value.length < 6) {
      //   callback(new Error("密码太短"));
      } else if (value.length > 6) {
        callback(new Error("密码长度只可以是6位"));
      } else {
        callback();
      }
    };
    //限制300字以内
    const isvalidateLimit = (rule, value, callback) => {
      if (value && value.length > 300) {
        callback(new Error("最多 300 个汉字长度"));
      } else {
        callback();
      }
    };
    const isvalidaDate = (rule, value, callback) => {
      if (!value || value == "") {
        callback(new Error("请选择服务时间"));
      }else if(!this.orderForm.startTime || this.orderForm.startTime == ''){
        callback(new Error("请选择服务开始时间"));
      }else if(!this.orderForm.endTime || this.orderForm.endTime == ''){
        callback(new Error("请选择服务结束时间"));
      }else{
        callback()
      }
    };
    return {
      pickerOptions1:{
        disabledDate(time) {
          return time.getTime() < (Date.now() - 3600 * 1000 * 24);
        },
      },
      orderForm: {
        number: "1",
        timeBox:[],
        nthmen: "",
        payPwd:'',
        nexttime:'',
        startTime:'',
        endTime:'',
        condition:'',
        cancelReason:''
      },
      rules: {
          number:[
              { validator: isvalidateNumber, trigger: "blur" }
          ],
          timeBox:{
            time:[
              { required: true, message: "请选择预约时间", trigger: "change" }
            ]
          },
          nthmen:[
            { required: true, message: "请选择员工", trigger: "change" }
          ],
          cancelReason:[
            { required:true, message:"请选择原因", trigger:"change"}
          ],
          payPwd:[
            { required: true, message: "请输入消费密码", trigger: "blur" },
            { validator: validatePass, trigger: "blur"}
          ],
          nexttime:[
            // { message: "请选择下次预约时间", trigger: "change" }
            {validator: isvalidaDate, trigger:'change'}
          ],
          condition:[
            { message: "请输入调理小结", trigger: "blur" },
            { validator: isvalidateLimit, trigger: "blur" }
          ]
      },
      shopHours:'',
      erCode:false,
      staffList:'',
      allStaffList:'',
      openFlag:false,
      setpayPwd:0, //未设置消费密码
    };
  },
  watch: {
    'dialogType'(val){
      this.$refs.orderForm.resetFields();
      this.orderForm = this.$options.data().orderForm;
      this.erCode = false;
      if(val == 2){
        this.techList();
      }
      this.openFlag = false
    },
    'curRowchoose'(){
      this.$refs.orderForm.resetFields();
      this.orderForm = this.$options.data().orderForm;
      this.erCode = false;
      this.openFlag = false
    },
    'dialogTableVisible'(val){
      this.erCode = false;
      if(this.dialogType == 3 && val){
        // 开单先检索会员是否设置消费密码
        this.sarchMemPwd()
      }
      if(this.dialogType == 4 && val){
        this.getshopHour();
      }
    }
  },
  computed:{
    conputedNow(){
      // 和本地时间做对比
      let time = '09:00'
      if(this.shopHours){
        time = this.shopHours.split('-')[0].split(':')[0] > 9 ? this.shopHours.split('-')[0] : '0'+this.shopHours.split('-')[0];
        let hours = new Date().getMinutes() > 30 ? new Date().getHours()+1+':00' : new Date().getHours()+':30';
        let nowDate = formatDate(this.orderForm.nexttime,'yyyy-MM-dd'),location=formatDate(new Date(),'yyyy-MM-dd');
        time = nowDate == location ? (Number(time.split(':')[0]) > Number(hours.split(':')[0]) ? time : hours) : time
        if(Number(time.split(':')[0]) >= Number(this.shopHours.split('-')[1].split(':')[0]) && Number(time.split(':')[1]) >= Number(this.shopHours.split('-')[1].split(':')[1])){
          this.$message({
            type: "warning",
            message: '今日已无预约时间，请选择明天'
          });
        }
      }
      return time;
    },
    computedEnd(){
      let time = '17:00'
      if(this.shopHours){
        time = this.shopHours.split('-')[1];
        let hours = Number(time.split(':')[0])-1;
        time = (hours<10?'0'+hours:hours) +':'+  time.split(':')[1]
      }
      return time;
    },
    computedStart(){
      let time = '10:00'
      if(this.shopHours){
        time = this.shopHours.split('-')[0];
        let hours = Number(time.split(':')[0])+1;
        time = (hours<10?'0'+hours:hours) +':'+  time.split(':')[1]
      }
      return time;
    },
    curStaffList(){
      if(this.staffList){
        return this.staffList.filter(function (staff) {
          return staff.status == 0
        })
      }
    },
  },
  created() {
    if(this.dialogType == 2){
      this.techList()
    }else if(this.dialogType == 3){
      // 开单先检索会员是否设置消费密码
      this.sarchMemPwd()
    }else if(this.dialogType == 4){
      this.getshopHour();
    }
    this.openFlag = false
  },
  methods: {
    operaEntryDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
      var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    getshopHour(){
      storeInfo().then(res => {
        if (res.code == 1) {
          this.shopHours = res.data.shopHours;
        }
      });
    },
    sarchMemPwd(){
      memDetail({
        phone: this.curRowchoose.memberPhone
      }).then(res=>{
        if (res.data) {
          if (!res.data.accountOffList || res.data.accountOffList.length == 0) {
            // 提交后先走接口1（加入本店会员） 再走接口2（更新会员消费密码）
            this.setpayPwd = 2;
          } else if(res.data.accountOffList[0].passwordOff == 0){
            // 提示去设置密码，提交后走更新会员消费密码接口（updateMemberOffPassword）
            this.setpayPwd = 1;
          }else{
            this.setpayPwd = 0;
          }
        }
      })
    },
    toSetPwd(){
      this.$emit('cancelDialog',{setpayPwd:this.setpayPwd,memberId:this.curRowchoose.memberId})
    },    
    techList(){
      allStaff({
        status:'1',
        deleteFlag:'0',
        postId:'0'
      }).then(res=>{
        this.allStaffList = res.data;
      })
      technicianList({
        // status:'1',
        // deleteFlag:'0',
        // postId:'0'
      }).then(res=>{
        this.staffList = res.data;
      })
    },
    timeNumber(){
      // 修改预约人数下面的时间增加
      this.orderForm.timeBox=[];
      for(let i=0;i<this.orderForm.number-1;i++){
        this.orderForm.timeBox.push({time:''})
      }
    },
    close(){
      this.$message({
          type: "info",
          message: "已取消"
      });
      this.$emit('closeDialog',false)
    },
    confirm(){
      this.$refs.orderForm.validate(valid => {
          if (valid) {

          } else {
              console.log("error submit!!");
              return false;
          }
      })
    },
    submit(){
      // 提交
      this.$refs.orderForm.validate(valid => {
          if (valid) {
            if(this.dialogType == 4){
              // 结束服务单
              if(!this.nextPart){
                // 预约时间后结束
                this.openFlag = true;
                this.orderForm.nexttime = formatDate(this.orderForm.nexttime,'yyyy-MM-dd ');
                appointNextOrderServe({
                  orderServeId:this.curRowchoose.id,
                  scheduleStartTime:this.dialogType === 1 ? null : this.orderForm.nexttime+this.orderForm.startTime+':00',
                  scheduleEndTime:this.dialogType === 1 ? null : this.orderForm.nexttime+this.orderForm.endTime+':00',
                }).then(res=>{
                  this.$message({
                    message: res.msg,
                    type: res.code == 1 ? "success" : "error"
                  });
                  if(res.code == 1){
                    this.$emit('closeDialog', 'nextPart');
                  }
                  this.openFlag = false;
                })
              }else{
                this.openFlag = true;
                endOrderServe({
                  orderServeId:this.curRowchoose.id,
                  // scheduleStartTime:this.orderForm.nexttime,
                  remark:this.orderForm.condition
                }).then(res=>{
                  if(res.code == 1){
                    // 预约下次服务关闭
                    // this.$emit('refresh',res.data);
                    // if(res.data.isAppointStatus != 1){
                      this.$emit('closeDialog', false);
                    // }                  
                  }else{
                    this.$message({
                      message: res.msg,
                      type: res.code == 1 ? "success" : "error"
                    });
                  }
                  this.openFlag = false;
                })
              }
            }else if(this.dialogType == 2){
              // 人工派单
              this.openFlag = true;
              insertManualAssign({
                orderServeId:this.curRowchoose.id,
                technicianIdStore:this.orderForm.nthmen
              }).then(res=>{
                this.$message({
                  message: res.msg,
                  type: res.code == 1 ? "success" : "error"
                });
                if(res.code == 1){
                  this.$emit('closeDialog', false);
                }
                this.openFlag = false;
              })
            }
          } else {
              this.openFlag = false;
              console.log("error submit!!");
              return false;
          }
      })
    },
    cancelSubmit(){
      this.$refs.orderForm.validate(valid => {
          if (valid) {
            this.openFlag = true;
            cancelServiceOrder({
              orderServeId:this.curRowchoose.id,
              reason:this.orderForm.cancelReason
            }).then(res=>{
              this.$message({
                message: res.msg,
                type: res.code == 1 ? "success" : "error"
              });
              if(res.code == 1){
                this.$emit('closeDialog', false);
              }
              this.openFlag = false;
            })
          }else{
            this.openFlag = false;
              console.log("error submit!!");
              return false;
          }
      })
    },
    forgetPwd(){
      // 展开下面二维码
      this.erCode = true;
    },
    openOrder(){
      // 开单提交
      this.$refs.orderForm.validate(valid => {
          if (valid) {
            this.openFlag = true;
            // checkMemAccountPwd({
            //   memberId:this.curRowchoose.memberId,
            //   passwordOff:this.operaEntryDES(this.orderForm.payPwd)
            // }).then(res=>{
              // if(res.code == 1){
                // this.openFlag = true;
                startOrderServe({
                  orderServeId:this.curRowchoose.id
                }).then(res=>{
                  this.$message({
                    message: res.msg,
                    type: res.code == 1 ? "success" : "error"
                  });
                  if(res.code == 1){
                    this.$emit('closeDialog', false);
                    this.orderForm.payPwd = '';
                    this.openFlag = false;
                  }else{
                    this.openFlag = false;
                  }
                })
              // }else{
              //   this.openFlag = false;
              //   this.$message({
              //     message: res.msg,
              //     type: "error"
              //   });
              // }
            // })
          } else {
            this.openFlag = false;
              console.log("error submit!!");
              return false;
          }
      })
    }
  }
};
</script>
<style lang="less">
.dialogVisible {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .seize {
    height: 20px;
  }
  .el-dialog__title {
    font-weight: bold;
  }
  .el-dialog__body{
    max-height: 610px;
    overflow-y: auto;
    padding: 25px 20px 30px 25px;
  }
  .scanFont{
    p{
      font-size: 15px;
      line-height: 28px;
    }
  }
  .el-form-item {
    margin-bottom: 0;
    .forget{
      cursor: pointer;
    }
    .grey{
      color: #9FA3AD;
    }
    .el-form-item__label {
      color: #999;
    }
    &.lineH {
      .el-form-item__content {
        line-height: 25px;
        padding-top: 8px;
      }
    }
    &.paypass{
      .el-form-item__error{
        left: 260px;
      }
    }
    &.nextTimeChoose{
      .el-form-item__error{
        left: 220px;
      }
    }
  }
  .el-form-item__content {
    text-align: left;
    .el-form-item__error{
      top: 8px;
      left: 200px;
    }
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
    border-radius: 18px;
  }
  .el-textarea__inner{
    height: 100%;
    border-radius: 18px;
  }
  .el-button.redBtn {
    background: #F83B56;
    color: #fff;
  }

  .el-button.darkBtn {
    background: #3b404f;
    color: #fff;
  }
  .btnOptions {
    margin:50px 0 20px 0;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/operatingFloor/confirmTel.vue